import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
// Обновление профиля (мок): прокидываем на реальный бекенд
Mock.onPost('/api/profile/update').reply(async (config) => {
    try {
        const data = JSON.parse(config.data)
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.post(`${apiUrl}/profile/update/?apiKey=${apiKey}`, data)
        return [200, response.data || { result: 'success', message: 'Профиль обновлён' }]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка сохранения профиля' }]
    }
})

// Диагностика времени на бэке: timezone PHP, now(), offset пользователя
Mock.onGet('/api/profile/time-debug').reply(async () => {
    try {
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.get(`${apiUrl}/profile/time-debug/?apiKey=${apiKey}`)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка получения time-debug' }]
    }
})

Mock.onGet('/api/profile/ext-api/settings').reply(async () => {
    try {
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.get(`${apiUrl}/profile/ext-api/settings/?apiKey=${apiKey}`)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка получения настроек ext api' }]
    }
})

Mock.onGet('/api/profile/ext-api/key/generate').reply(async () => {
    try {
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.get(`${apiUrl}/profile/ext-api/key/generate/?apiKey=${apiKey}`)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка генерации api ключа' }]
    }
})

Mock.onPost('/api/profile/ext-api/key/create').reply(async (config) => {
    try {
        const data = JSON.parse(config.data || '{}')
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.post(`${apiUrl}/profile/ext-api/key/create/?apiKey=${apiKey}`, data)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка создания api ключа' }]
    }
})

Mock.onPost('/api/profile/ext-api/key/toggle').reply(async (config) => {
    try {
        const data = JSON.parse(config.data || '{}')
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.post(`${apiUrl}/profile/ext-api/key/toggle/?apiKey=${apiKey}`, data)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка изменения api ключа' }]
    }
})

Mock.onPost('/api/profile/ext-api/key/delete').reply(async (config) => {
    try {
        const data = JSON.parse(config.data || '{}')
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.post(`${apiUrl}/profile/ext-api/key/delete/?apiKey=${apiKey}`, data)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка удаления api ключа' }]
    }
})

Mock.onPost('/api/profile/ext-api/key/reveal').reply(async (config) => {
    try {
        const data = JSON.parse(config.data || '{}')
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.post(`${apiUrl}/profile/ext-api/key/reveal/?apiKey=${apiKey}`, data)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка получения api ключа' }]
    }
})

Mock.onPost('/api/profile/ext-api/webhook/save').reply(async (config) => {
    try {
        const data = JSON.parse(config.data || '{}')
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const response = await axios.post(`${apiUrl}/profile/ext-api/webhook/save/?apiKey=${apiKey}`, data)
        return [200, response.data || {}]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Ошибка сохранения webhook' }]
    }
})
